export const unique = <T>(value: T, index: number, self: T[]): boolean => {
  return self.indexOf(value) === index
}

export const groupBy = <T>(options: T[], column: keyof T): any[] => {
  return (options || []).map((option) => option[column])
}
